export default __webpack_public_path__ + "assets/8a0c9b195f41f8433c83a8e184b72eb4.ttf";